import { ProgramInfiniteSessionEntity } from "@/modules/sessions/entities/programInfiniteSessionEntity"
import { ProgramOnOffSessionEntity } from "@/modules/sessions/entities/programOnOffSessionEntity"
import { useServicesContext } from "@modules/core/services/services.context"
import { useMutation, useQueryClient } from "@tanstack/react-query"

export function useSetSessionCompleted() {
  const { programInfiniteSessionApi, programOnOffSessionApi } = useServicesContext()
  const queryClient = useQueryClient()

  const { mutateAsync: setSessionCompleted, isPending } = useMutation({
    mutationFn: async ({
      session,
      completed,
    }: {
      session: ProgramInfiniteSessionEntity | ProgramOnOffSessionEntity
      completed: boolean
    }) => {
      if (session instanceof ProgramInfiniteSessionEntity) {
        await programInfiniteSessionApi.setSessionCompleted(session.id, completed)
        return
      }
      if (session instanceof ProgramOnOffSessionEntity) {
        await programOnOffSessionApi.setSessionCompleted(session.id, completed)
        return
      }
      throw new Error("Session update is not supported for this session type")
    },
    onSuccess: async (_, { session }) => {
      await queryClient.invalidateQueries({
        queryKey: ["programSession", session.id],
      })
    },
  })

  return {
    setSessionCompleted,
    isPending,
  }
}
